import { useEffect, useState } from "react";

export const BaseColors = [
  "#4CB353",
  "#E72F2D",
  "#FCCF39",
  "#1A77BD",
]

export const useDrawerColors = () => {
  const [drawerColors,setDrawerColors] = useState(BaseColors);
    useEffect(() => {
      const generateColors = () => {
      // Create a pool of 3 distinct colors by copying the array and shuffling it
      const shuffledBase = [...BaseColors].sort(() => 0.5 - Math.random());
      const selectedDistinct = shuffledBase.slice(0, 3);
      
      // Pick one more color from the selected 3 to be the single allowed repetition
      const repeatedColor = selectedDistinct[Math.floor(Math.random() * selectedDistinct.length)];
      
      // Combine them to get exactly 4 colors (min 3 distinct)
      const finalColors = [...selectedDistinct, repeatedColor];
      
      // Shuffle the final 4 colors so the repeated color isn't always at the end
      const finalShuffled = finalColors.sort(() => 0.5 - Math.random());
      
      setDrawerColors(finalShuffled);
    };

    // Run immediately on mount
    generateColors();

    // Set up the interval to run every 2 minutes (120,000 ms)
    const intervalId = setInterval(generateColors, 60000);

    // Cleanup interval on unmount
    return () => clearInterval(intervalId);
  }, []); // Run once on mount

  return {
    drawerColors,
  }
}
